import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DarkModeService {
  themeSubject: BehaviorSubject<string> = new BehaviorSubject<string>('light');
  theme$: Observable<string> = this.themeSubject.asObservable();

  constructor() {
    this.setTheme();
  }

  setTheme(theme: string | null = null): void {
    if (!theme) {
      const themeJSON: string | null = localStorage.getItem('theme');
      if (!themeJSON) return this.setTheme('light');

      this.themeSubject.next(themeJSON);
      this.applyTheme(themeJSON);
    } else {
      localStorage.setItem('theme', theme);
      this.themeSubject.next(theme);
    }
  }

  toggleTheme(): void {
    const theme: string = this.themeSubject.getValue();
    const newTheme: string = theme === 'light' ? 'dark' : 'light';
    this.applyTheme(newTheme);
    this.setTheme(newTheme);
  }

  applyTheme(theme: string): void {
    if (theme === 'dark') {
      document.body.classList.add('dark');
    } else {
      document.body.classList.remove('dark');
    }
  }
}
